import { CustomUseQueryOptions } from '../types';
import { hasNonEmptyProp } from '@/libs/common/utils';
import { getOptionOutAmount, GetOptionOutAmountProps } from '@/libs/sdk/contracts';
import { useQuery } from '@tanstack/react-query';
import type { PublicClient } from 'viem';

export const useBuyWin = (
  client: PublicClient,
  params?: GetOptionOutAmountProps,
  options?: CustomUseQueryOptions<bigint>
) => {
  const { queryKey, enabled = true, ...rest } = options || {};
  return useQuery({
    ...rest,
    enabled: enabled && hasNonEmptyProp(params, true),
    queryKey: [queryKey, 'UseBuyWin', client, params],
    queryFn: async () => await getOptionOutAmount(params!, client),
  });
};
